import { LOCALE_ID, NgModule } from "@angular/core";
import { registerLocaleData, APP_BASE_HREF } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpModule } from "@angular/http";

import { CoreModule } from "./@core/core.module";
// import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "./@theme/theme.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "./auth/auth.service";
import { AuthGuard } from "./guards/auth.guard";
import { AlertService } from "./alert/alert.service";
import { AsyncLocalStorageModule } from "angular-async-local-storage";
import { AppService } from "./app.service";
import { FunctionService } from "./provider/function.service";
import localePt from "@angular/common/locales/pt";

registerLocaleData(localePt, "pt-BR");
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    AppRoutingModule,
    // SweetAlert2Module.forRoot(),
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    // AgmCoreModule.forRoot({
    //   apiKey: "AIzaSyBzeezjoCW8uGgW4OUCECVF7Wpt6wv0BUI",
    //   language: "pt-BR",
    //   region: "BR",
    // }),
    // AgmDirectionModule,
    AsyncLocalStorageModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: "pt-BR" },
    AuthService,
    AuthGuard,
    AlertService,
    FunctionService,
    AppService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/app.module.ts